import { resources } from "@constants/hardcoded-strings";
import { AXNUIContent } from "@iddataweb/idw-common-ui/types";
import { TabTitleWithErrorCount } from "@containers/common/tab-title-with-error-count/tab-title-with-error-count";
import { ErrorAlert } from "@containers/common/error-alert/error-alert";
import { ThemingFormContentValidationErrors } from "@idw-types/common/validation/common/theming-validation-errors";
import { PreviewEntityTypes } from "@enums/preview-entity-types";

export const getThemingFormContentValidationErrors = (
    previewEntityType: PreviewEntityTypes,
    isUsingThemedUI: boolean,
    hasDisplayableDocumentCaptureAttributes: boolean,
    axnuiContent: AXNUIContent
): ThemingFormContentValidationErrors => {
    let count = 0;
    let asyncSubmissionCompleteTextError = null;
    let asyncSubmissionInProgressTextError = null;
    let cancelButtonTextError = null;
    let captureMessageError = null;
    let completeStatusTextError = null;
    let continueInfoEmailTextError = null;
    let continueInfoPhoneTextError = null;
    let detailTextError = null;
    let failedStatusTextError = null;
    let incompleteStatusTextError = null;
    let noRetriesLeftTextError = null;
    let previewTextMultipleError = null;
    let previewTextSingleError = null;
    let statusTextError = null;
    let unableToVerifyStatusTextError = null;

    if (isUsingThemedUI && hasDisplayableDocumentCaptureAttributes && previewEntityType === PreviewEntityTypes.VERIFICATION_SERVICE) {
        if (!axnuiContent.form.asyncInput.captureMessage) {
            count += 1;
            captureMessageError = <ErrorAlert><span>{resources.common.requiredField}</span></ErrorAlert>;
        }
        if (!axnuiContent.form.asyncInput.status) {
            count += 1;
            statusTextError = <ErrorAlert><span>{resources.common.requiredField}</span></ErrorAlert>;
        }
        if (!axnuiContent.form.asyncInput.completeStatus) {
            count += 1;
            completeStatusTextError = <ErrorAlert><span>{resources.common.requiredField}</span></ErrorAlert>;
        }
        if (!axnuiContent.form.asyncInput.incompleteStatus) {
            count += 1;
            incompleteStatusTextError = <ErrorAlert><span>{resources.common.requiredField}</span></ErrorAlert>;
        }
        if (!axnuiContent.form.asyncInput.failedStatus) {
            count += 1;
            failedStatusTextError = <ErrorAlert><span>{resources.common.requiredField}</span></ErrorAlert>;
        }
        if (!axnuiContent.form.asyncInput.unableToVerifyStatus) {
            count += 1;
            unableToVerifyStatusTextError = <ErrorAlert><span>{resources.common.requiredField}</span></ErrorAlert>;
        }
        if (!axnuiContent.form.imageAttribute.previewTextSingle) {
            count += 1;
            previewTextSingleError = <ErrorAlert><span>{resources.common.requiredField}</span></ErrorAlert>;
        }
        if (!axnuiContent.form.imageAttribute.previewTextMultiple) {
            count += 1;
            previewTextMultipleError = <ErrorAlert><span>{resources.common.requiredField}</span></ErrorAlert>;
        }
        if (!axnuiContent.common.asyncModal.continueInfoEmail) {
            count += 1;
            continueInfoEmailTextError = <ErrorAlert><span>{resources.common.requiredField}</span></ErrorAlert>;
        }
        if (!axnuiContent.common.asyncModal.continueInfoPhone) {
            count += 1;
            continueInfoPhoneTextError = <ErrorAlert><span>{resources.common.requiredField}</span></ErrorAlert>;
        }
        if (!axnuiContent.common.asyncModal.details) {
            count += 1;
            detailTextError = <ErrorAlert><span>{resources.common.requiredField}</span></ErrorAlert>;
        }
        if (!axnuiContent.common.asyncModal.cancel) {
            count += 1;
            cancelButtonTextError = <ErrorAlert><span>{resources.common.requiredField}</span></ErrorAlert>;
        }
        if (!axnuiContent.common.asyncModal.noRetriesLeft) {
            count += 1;
            noRetriesLeftTextError = <ErrorAlert><span>{resources.common.requiredField}</span></ErrorAlert>;
        }
        if (!axnuiContent.common.asyncModal.complete) {
            count += 1;
            asyncSubmissionCompleteTextError = <ErrorAlert><span>{resources.common.requiredField}</span></ErrorAlert>;
        }
        if (!axnuiContent.common.asyncModal.waiting) {
            count += 1;
            asyncSubmissionInProgressTextError = <ErrorAlert><span>{resources.common.requiredField}</span></ErrorAlert>;
        }
    }

    return {
        asyncSubmissionCompleteTextError,
        asyncSubmissionInProgressTextError,
        cancelButtonTextError,
        captureMessageError,
        completeStatusTextError,
        continueInfoEmailTextError,
        continueInfoPhoneTextError,
        detailTextError,
        failedStatusTextError,
        incompleteStatusTextError,
        noRetriesLeftTextError,
        previewTextMultipleError,
        previewTextSingleError,
        statusTextError,
        unableToVerifyStatusTextError,
        count: count,
        tabTitle: <TabTitleWithErrorCount
            tabName={resources.pages.verificationServiceDetails.tabs.theming.subTabs.formContent.tabName}
            errorCount={count}
        />
    };
};